import 'Plugins/openClosePlugin';

// open-close init
export default function initOpenClose() {
	ResponsiveHelper.addRange({
		'..767': {
			on: function() {
				jQuery('.filter-open-close').openClose({
					activeClass: 'active',
					opener: '.opener',
					slider: '.slide',
					animSpeed: 400,
					effect: 'slide',
					onInit: function() {
						this.links = this.slider.find('a');

						this.links.on('click', (e) => {
							this.opener.text(jQuery(e.target).text());
							this.hideSlide();
						});
					}
				});
			},
			off: function() {
				jQuery('.filter-open-close').openClose('destroy');
			}
		}
	});

	ResponsiveHelper.addRange({
		'..1023': {
			on: function() {
				jQuery('.finder-open-close').openClose({
					activeClass: 'active',
					opener: '.opener',
					slider: '.slide',
					animSpeed: 400,
					effect: 'slide'
				});
			},
			off: function() {
				jQuery('.finder-open-close').openClose('destroy');
			}
		}
	});

	ResponsiveHelper.addRange({
		'..767': {
			on: function() {
				jQuery('.resource-aside').openClose({
					activeClass: 'active',
					opener: '.categories-opener',
					slider: '.categories-slide',
					animSpeed: 400,
					effect: 'slide',
					onInit: function() {
						this.links = this.slider.find('a');

						this.links.on('click', (e) => {
							this.opener.text(jQuery(e.target).text());
							this.hideSlide();
						});
					}
				});
			},
			off: function() {
				jQuery('.resource-aside').openClose('destroy');
			}
		}
	});
}